import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top smoothly after a small delay to prevent visual glitch
    const timeout = setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: "instant", // or "smooth" if you want animation
      });
    }, 0); // Set to 0ms or 10ms if needed

    return () => clearTimeout(timeout);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
